import React from "react";
import contact_us_image from "../../assets/image/png/contact_us_heroimage.png";

const ContactUsHero = () => {
  return (
    <div className="" >
      <div className="position-relative">
        <img
          height={480}
          className="w-100 obj-fit"
          src={contact_us_image}
          alt="contact_us_image"
        />
        <div className="position-absolute w-100 text-center  tranform_m">
          <h4 className=" fs_48 ff_raleway fw-bold text-white">
            Is your drone acting up<br className="d-md-block d-none"></br>{" "}
            or need a repair?
          </h4>
          <p className=" fs_37 ff_helvetica text-white">Let us help you.</p>
          <svg
            className="animate-bounce mx-auto d-block"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 4v14m0 0l-6-6m6 6l6-6"
              stroke="white"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default ContactUsHero;